var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2051 29.7567C18.2051 32.3905 20.2263 34.5138 22.7376 34.5138H27.8622C30.0467 34.5138 31.823 32.6559 31.823 30.3692C31.823 27.8784 30.7409 27.0005 29.128 26.4288L20.9001 23.5705C19.2872 22.9988 18.2051 22.1209 18.2051 19.6301C18.2051 17.3434 19.9813 15.4855 22.1659 15.4855H27.2905C29.8017 15.4855 31.823 17.6088 31.823 20.2426",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.75V37.25",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45.4166C36.2759 45.4166 45.4167 36.2758 45.4167 25C45.4167 13.7242 36.2759 4.58331 25 4.58331C13.7242 4.58331 4.58337 13.7242 4.58337 25C4.58337 36.2758 13.7242 45.4166 25 45.4166Z",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.b760e37c94e3a9a058e8c5e44df73c29.svg";
export { ForwardRef as ReactComponent };